// extracted by mini-css-extract-plugin
export default {"scrollContainer":"scrollbar_scrollContainer__2P0q-"};